<button
  class="{{paddingClass}} flex w-full items-center justify-between text-left font-medium text-neutral-900 border-t border-gray-200"
  [ngClass]="{
    'border-none': noBorder,
  }"
  type="button"
  (click)="accordionPanel.setOpen(!accordionPanel.open)"
>
  <div class="text-neutral-900 text-base font-medium w-full">
    <ng-content></ng-content>
  </div>
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 20 20"
    class="h-6 w-6 shrink-0 duration-200"
    [class.rotate-180]="accordionPanel.open"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clip-rule="evenodd"
    ></path>
  </svg>
</button>
